// Import the i18next singleton directly (not '@/i18n/config') — the app
// config would create a circular import: i18n/config → config/config → …
import i18n from 'i18next';

export const DEV_ONLY =
  import.meta.env.VITE_ENVIRONMENT === 'local' || import.meta.env.VITE_ENVIRONMENT === 'develop';

export const HAND_SHAKE_MAX_RETRY = 1;
export const SKIP_ENCRYPT = import.meta.env.VITE_SKIP_ENCRYPT === 'true';

// The public origin of this deployment's panel, with any trailing slash trimmed
// so callers can append a path. Invite links leave the app entirely — they are
// copied and QR-scanned by people outside it — so they have to carry the
// environment's own host; a hardcoded production base would send a tester's
// invite into the live company. Read plainly, with no window.location.origin
// fallback: an unset variable is a deploy error and should fail visibly.
export const ADMIN_PANEL_URL = (import.meta.env.VITE_ADMIN_PANEL_URL ?? '').replace(/\/+$/, '');

// Google Maps browser key for the live-locations map. An empty key keeps the
// map area on its quiet placeholder instead of a broken embed.
export const MAP_API_KEY = import.meta.env.VITE_MAP_API_KEY ?? '';

// Origin of the Socket.IO server (live tracking). Defaults to the API's own
// origin — VITE_API_PATH carries the /api/v1 prefix, which socket namespaces
// don't use. VITE_SOCKET_URL overrides it when sockets are served elsewhere.
const socketOrigin = (): string => {
  const explicit = import.meta.env.VITE_SOCKET_URL;
  if (explicit) return explicit.replace(/\/+$/, '');
  try {
    return new URL(import.meta.env.VITE_API_PATH ?? '', window.location.origin).origin;
  } catch {
    return window.location.origin;
  }
};
export const SOCKET_URL = socketOrigin();

export const isRTL = () => {
  if (i18n.language === 'ar') return true;
  else return false;
};
